import { render, staticRenderFns } from "./form_transfor.vue?vue&type=template&id=691c6f76&scoped=true"
import script from "./form_transfor.vue?vue&type=script&lang=js"
export * from "./form_transfor.vue?vue&type=script&lang=js"
import style0 from "./form_transfor.vue?vue&type=style&index=0&id=691c6f76&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691c6f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691c6f76')) {
      api.createRecord('691c6f76', component.options)
    } else {
      api.reload('691c6f76', component.options)
    }
    module.hot.accept("./form_transfor.vue?vue&type=template&id=691c6f76&scoped=true", function () {
      api.rerender('691c6f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/announcement_manage/form/components/form_transfor.vue"
export default component.exports